export default __webpack_public_path__ + "static/media/cross_icon.ef67913e.svg";